"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WebEmbedMessage;
(function (WebEmbedMessage) {
    WebEmbedMessage["EMBED_EVENT_MSG"] = "\u0192_wee";
    WebEmbedMessage["EMBED_REDIRECT_MSG"] = "\u0192_wer";
    WebEmbedMessage["EMBED_RESIZE_MSG"] = "\u0192_wes";
    WebEmbedMessage["EMBED_STYLE_SET_REQUEST_MSG"] = "\u0192_wessreq";
    WebEmbedMessage["EMBED_STYLE_SET_RESPONSE_MSG"] = "\u0192_wessres";
    WebEmbedMessage["EMBED_TOKEN_REQUEST_MSG"] = "\u0192_wetreq";
    WebEmbedMessage["EMBED_TOKEN_RESPONSE_MSG"] = "\u0192_wetres";
    WebEmbedMessage["EMBED_UNAUTHORIZED_MSG"] = "\u0192_weua";
})(WebEmbedMessage || (WebEmbedMessage = {}));
exports.default = WebEmbedMessage;
